'use client';

import { Button } from '@/components/atoms/Button';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function EventDetailError({ error, reset }: ErrorProps) {
  return (
    <div className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-2xl font-bold mb-2">This page didn&apos;t load</h1>
      <p className="text-muted-foreground mb-6">
        The event didn&apos;t load. Try again.
        {error.digest && (
          <span className="block mt-1 text-xs opacity-50">Error ID: {error.digest}</span>
        )}
      </p>
      <Button variant="accent" size="lg" onClick={reset}>
        Try again
      </Button>
    </div>
  );
}
